
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Exercise/[slug]",
      function () {
        return require("private-next-pages/Exercise/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Exercise/[slug]"])
      });
    }
  